import type { AttributeFilters } from '../attributeFilters';
import type { NonEmptyArray } from '../types/index';
import type { TableColumnSort, TableColumnWidths } from '../user/UserSettings';
import type { Filters } from './filters/filters';

/**
 * Data saved to database via API for "Get view URL" table feature
 */
export type TableSharedView = {
  autoSizedColumns?: boolean;
  columnVisibility?: Record<string, boolean>;
  columnWidth?: TableColumnWidths;
  attributeFilters?: AttributeFilters;
  filters?: Filters;
  orderedColumns?: NonEmptyArray<string>;
  /** ID of saved filter */
  selectedFilter?: string;
  sort?: TableColumnSort;
  webEndpoint: string;
};
